module.exports = __webpack_public_path__ + "img/mp3.21db30ab.svg";